export function isSafariOnIOSMobile(): boolean {
  const userAgent = window.navigator.userAgent;
  const platform = window.navigator.platform;
  const iosPlatforms = ['iPhone', 'iPad', 'iPod'];

  // Check if on an iOS platform
  const isIOS =
    iosPlatforms.includes(platform) ||
    /iPad|iPhone|iPod/.test(userAgent) ||
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document);

  // Safari on iOS mobile condition: isIOS && not in standalone mode
  return isIOS && !(window.navigator as any).standalone;
}

export function isWebInFlutter(): boolean {
  return navigator.userAgent.includes('Flutter');
}
